import React from 'react';
import VSCode from './Pages/VSCode';

const App = () => (
  <VSCode />
);

export default App;
